import { render, staticRenderFns } from "./TopStore.vue?vue&type=template&id=b0ae49aa"
import script from "./TopStore.vue?vue&type=script&lang=js"
export * from "./TopStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0ae49aa')) {
      api.createRecord('b0ae49aa', component.options)
    } else {
      api.reload('b0ae49aa', component.options)
    }
    module.hot.accept("./TopStore.vue?vue&type=template&id=b0ae49aa", function () {
      api.rerender('b0ae49aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/rank/TopStore.vue"
export default component.exports